var Import = /** @class */ (function () {
    function Import(element) {
        this.element = element;
        this.disable();
        this.initEvents();
    }
    Import.prototype.initEvents = function () {
        var _this = this;
        var fileInput = this.element.querySelector('input[type=file]');
        if (fileInput) {
            fileInput.addEventListener('change', function () {
                fileInput.value ? _this.enable() : _this.disable();
            });
        }
    };
    Import.prototype.disable = function () {
        this.element.querySelectorAll('input[type="submit"]').forEach(function (button) { return button.setAttribute('disabled', '1'); });
    };
    Import.prototype.enable = function () {
        this.element.querySelectorAll('input[type="submit"]').forEach(function (button) { return button.removeAttribute('disabled'); });
    };
    return Import;
}());
export default Import;
